import AccountUploadsService from './account-uploads-service';
import ApiConfig from './api-config';
import BandwidthTestClient from './bandwidth-test-client';
import Capabilities from './capabilities';
import Checkout from './checkout';
import ConfirmDialog from './confirm-dialog';
import EditOrCreateEventService from './edit-or-create-event-service';
import Facebook from './facebook';
import JSZip from './jszip';
import MeetingsService from './meetings-service';
import MultiPartUpload from './multi-part-upload';
import OneOrAllDialog from './one-or-all-dialog';
import Overlays from './overlays';

let module = angular.module('app.services', [
  AccountUploadsService.name,
  ApiConfig.name,
  BandwidthTestClient.name,
  Capabilities.name,
  Checkout.name,
  ConfirmDialog.name,
  EditOrCreateEventService.name,
  Facebook.name,
  JSZip.name,
  MeetingsService.name,
  MultiPartUpload.name,
  OneOrAllDialog.name,
  Overlays.name,
]);

export default module;



// WEBPACK FOOTER //
// ./app/services/_index.js